import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData, getDropdownIdsFromSelectArray } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { DIGITAL_BUSINESS_IDS } from 'views/pages/manage/common/hook/useCashierOfficeDropdown'
import moment from "moment";
import { CONCESSION_REFUND, DISCRETIONARY_REFUND, FULL_REFUND, SECURITY_REFUND, WITHDRAWAL_REFUND } from "../studentRefundRequest/multiTypeRefund/utils";
import { COMPLETION_REFUND, RECTIFICATION_REFUND } from "../studentRefundRequest/config";

export const getDropdowns = async () => {
    try {
        const resp = await Promise.all([
            dropdownMapping(
                endpoint.businessArea.getAllActiveV2,
                "businessAreaDispValue",
                "id",
                "regionId"
            ),
            dropdownMapping(
                endpoint.getRole.roleWithApprovalPermissions,
                "roleName",
                "id",
            ),
            dropdownMapping(endpoint?.businessUnitType?.getAllBusinessUnitType, 'businessUnitTypeDispValue', 'id'),
        ]);
        return {
            allActiveBu: resp[0],
            allActiveRoles: resp[1],
            branchType: [...(resp[2] || []), { label: "Advance", value: "advance" }],
            advanceBusinessAreas: resp[0]?.filter(bu => DIGITAL_BUSINESS_IDS.includes(bu?.label))
        };
    } catch (err) {
        console.error(err);
    }
}
const REFUND = 'refund';
export const hardcodeDropdown = {
    subType: [
        {
            id: 0,
            label: `Completion ${REFUND}`,
            value: COMPLETION_REFUND
        },
        {
            id: 1,
            label: `Security ${REFUND}`,
            value: SECURITY_REFUND
        },
        {
            id: 2,
            label: `Rectification ${REFUND}`,
            value: RECTIFICATION_REFUND
        },
        {
            id: 3,
            label: `Withdrawal ${REFUND}`,
            value: WITHDRAWAL_REFUND
        },
        {
            id: 4,
            label: `Full ${REFUND}`,
            value: FULL_REFUND
        },
        {
            id: 5,
            label: `Concession ${REFUND}`,
            value: CONCESSION_REFUND
        },
        {
            id: 6,
            label: `Discretionary ${REFUND}`,
            value: DISCRETIONARY_REFUND
        },
    ],

    isLoanComponent: [
        {
            id: 0,
            label: 'Yes',
            value: true
        },
        {
            id: 1,
            label: 'No',
            value: false
        },
    ],
    refundStatus: [
        {
            id: 1,
            label: "Approved",
            value: "Approved",
        },
        {
            id: 2,
            label: "Rejected",
            value: "Rejected",
        },
        {
            id: 3,
            label: "Expired",
            value: "Expired",
        },
        {
            id: 4,
            label: "Initiated",
            value: "Initiated",
        },
        {
            id: 5,
            label: "InProgress",
            value: "InProgress",
        },
        {
            id: 6,
            label: "Pending",
            value: "Pending",
        },
        {
            id: 7,
            label: "Completed",
            value: "Completed"
        },
        {
            id: 8,
            label: "Failed",
            value: "Failed"
        },
        {
            id: 9,
            label: "PartialFailed",
            value: "PartialFailed"
        }
    ],
};

export const openInNewTab = (url) => {
    window.open(window.location.origin + "/#/admin/" + url, "_blank").focus();
};


export const getFormattedDate = dateObj => dateObj ? moment(dateObj).format("DD/MM/YYYY") : "-";

export const getFormattedTime = dateObj => dateObj ? moment(dateObj).format("hh:mm A") : "-";

export const buildStudentDetails = (studentDetails, dropdowns, otherDetails) => {
    const { refundAmount, refundNumber, orderType, subOrderType } = otherDetails;

    const resp = studentDetails?.data?.studentApplicationDetailsSearchResponseDTOList?.[0] ?? {};

    const buDesc =
        dropdowns?.activeBusinessAreas?.find(bu => bu?.value == resp?.businessArea)?.businessAreaDesc || "";

    return {
        ...resp,
        term: resp?.term?.dispValue,
        refundAmount,
        refundNumber,
        orderType,
        subOrderType,
        bu: buDesc,
        sdCourseId: otherDetails?.sdCourseId,
        batchList: otherDetails?.batchList
    };
};
